import { CategoryCardItem } from '@helpers/CategoryCardItem';

class CategoryList {
  list: HTMLDivElement;

  constructor(list: HTMLDivElement) {
    this.list = list;

    this.initCardItems();
  }

  initCardItems() {
    const cards = this.list.querySelectorAll<HTMLDivElement>('.arjo-o-category-card');

    cards.forEach((card) => new CategoryCardItem(card));
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const lists = document.querySelectorAll<HTMLDivElement>('.arjo-o-category-list');

  lists.forEach((list) => new CategoryList(list));
});

export {};
